import { Table } from 'antd';
import { useEffect, useState } from 'react';
import { FaEdit, FaTrash } from "react-icons/fa";
import { getAsociaciones, asignarAsociacion } from 'services/Asociaciones';

const TableAssociations = ({ isLoading, onEdit }) => {
  const [dataSource, setDataSource] = useState([]);
  const [asociaciones, setAsociaciones] = useState([])

  useEffect(() => {
    obtenerAsociaciones();
  }, []);


  async function obtenerAsociaciones() {
    const data = await getAsociaciones()
    setDataSource(data);

    setAsociaciones(data)
  }

  const handleEdit = (id) => {
    const asociacionEdit = getAsociacion(id);
    console.log(id)

    // console.log(asociacionEdit)
    if (onEdit) {
      onEdit(asociacionEdit)
    }
  };

  const handleDelete = (id) => {
    const asociacionEdit = getAsociacion(id);
    if (onEdit) {
      onEdit(asociacionEdit)
    }
  };

  const getAsociacion = (id) => {
    return asociaciones.filter((item) => item.id === id);
  };

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Fecha desde',
      dataIndex: 'fecha_desde',
      key: 'fecha_desde',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Fecha hasta',
      dataIndex: 'fecha_hasta',
      key: 'fecha_hasta',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Acciones',
      dataIndex: 'acciones',
      key: 'acciones',
      render: (text, record) => (
        <div className='flex gap-4'>
          <a
            href={`asociaciones/${record.id}`}
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

              handleEdit(record.id);
            }}
          >
            <FaEdit />
          </a>

          <a
            href={`asociaciones/${record.key}`}
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

              handleDelete(record.key);
            }}
          >
            <FaTrash />
          </a>
        </div>
      ),
    },
  ];

  return (
    <div className='w-full flex min-h-40 rounded-b-md items-start flex-col pb-10'>
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={isLoading}
        className="w-full bg-white rounded-b-md p-8 transition-all"
        rowKey="key"
        pagination={false}
      />
    </div>
  );
};

export default TableAssociations;
